import { CalendarModel } from '../models/calendar.model';
import { DateHelper } from './date.helper';

/**
 * Leitura do controle de envio por dia do evento de calendario.
 *
 * A janela de uma coleta dura ate `awaitingDays` dias e cada um tem o seu
 * proprio contato a fazer, entao "ja foi enviado" e uma pergunta por dia, nao
 * por evento. `status` continua respondendo em que pe esta a coleta.
 *
 * Evento sem o mapa `sends` conta como pendente em qualquer dia, inclusive se
 * o status for 'sended': o dia daquele envio nao foi registrado e chutar um
 * esconderia um contato que ainda precisa acontecer.
 */
class CalendarSendHelper {
  /** Mesma chave que o mapa usa e que `filters.byDateStart` ja grava. */
  static dayKey(date: string | Date): string {
    return DateHelper.formatDate(date, 'YYYY-MM-DD');
  }

  static wasSentOn(event: CalendarModel, day: string): boolean {
    return event.sends?.[day] !== undefined;
  }

  /** Quantos envios ja sairam, em qualquer dia: e o numero da tentativa. */
  static countSends(event: CalendarModel): number {
    return Object.keys(event.sends ?? {}).length;
  }
}

export { CalendarSendHelper };
